import { render, staticRenderFns } from "./EmptyOrders.vue?vue&type=template&id=c9979032&"
import script from "./EmptyOrders.vue?vue&type=script&lang=js&"
export * from "./EmptyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports